import PropTypes from "prop-types"
import { useEffect, useState } from "react"
import { Banner, Spinner } from "@shopify/polaris"
import "stylesheets/components/MetabaseChart.scss"
import ScoreChartErrorBoundary from "components/ErrorBoundary/ScoreChartErrorBoundary"
import useMetabase from "hooks/useMetabase"
import { useTranslation } from "react-i18next"

const MetabaseChartMolecule = ({
  verdikt_alias,
  compared_nodes_id,
  website_id,
}) => {
  const { questionUrl, isLoading, error, hasData } = useMetabase(
    verdikt_alias,
    compared_nodes_id,
    website_id
  )
  const { t } = useTranslation()

  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    setLoaded(false)
  }, [questionUrl])

  if (error) {
    const errorLower = (error || "").toString().toLowerCase()
    const isDashboardNotFound = errorLower.includes(
      "no metabase environment found for the request"
    )

    if (isDashboardNotFound) {
      return (
        <div className="metabase-chart-container">
          <div style={{ padding: 12, height: "100%" }}>
            <Banner
              status="warning"
              title={t("error_boundary:metabase_dashboard_not_available.title")}
            >
              <p style={{ margin: 0 }}>
                {t(
                  "error_boundary:metabase_dashboard_not_available.description"
                )}
              </p>
            </Banner>
          </div>
        </div>
      )
    }

    return <ScoreChartErrorBoundary />
  }

  if (!isLoading && !hasData) {
    return <ScoreChartErrorBoundary />
  }

  const showSpinner = isLoading || !loaded || !questionUrl

  return (
    <div className="metabase-chart-container">
      {showSpinner && (
        <div className="metabase-chart-spinner">
          <Spinner />
        </div>
      )}
      {questionUrl && (
        <iframe
          src={questionUrl.toString()}
          className={`metabase-chart-iframe ${loaded ? "" : "is-hidden"}`}
          title={`Metabase Chart ${verdikt_alias}`}
          onLoad={() => setLoaded(true)}
          loading="lazy"
        />
      )}
    </div>
  )
}

MetabaseChartMolecule.propTypes = {
  verdikt_alias: PropTypes.string.isRequired,
  compared_nodes_id: PropTypes.array,
  website_id: PropTypes.number,
}

export default MetabaseChartMolecule
